export default __webpack_public_path__ + "static/media/icon-bank.380ab003.webp";